import HelperService from "../../../StarterKit/Service/Bll/HelperService";
import ApiKpi from "../Api/ApiKpi";

export default class KpiService {
    #helper;
    #api;

    constructor() {
        this.#api = new ApiKpi();
        this.#helper = new HelperService();
    }

    getPage() {
        return location.pathname
    }

    async fetchData(params) {
        const isMargeRoute = location.pathname.includes('marge');
        const isCARoute = location.pathname.includes('ca') && !location.pathname.includes('ca_detail');
        const {navigate, logged, showLoader, hideLoader, setKpi, isMobile} = params;
        const page = this.getPage()

        function getFilterQuery(dates, isMargeRoute, isCARoute, isMobile) {


            if (localStorage.getItem("filteredData") || localStorage.getItem("dates")) {
                const dateQuery = KpiService.getDateQuery(dates, true);
                const filteredDataQuery = KpiService.getFilteredDataQuery(JSON.parse(localStorage.getItem("filteredData")) ?? {});
                console.log([...dateQuery, ...filteredDataQuery].join('&'))
                return [...dateQuery, ...filteredDataQuery].join('&');
            } else {
                const currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                const currentDay = String(currentDate.getDate()).padStart(2, '0');

                const creationEndDate = dates?.creation?.end
                    ? new Date(dates.creation.end)
                    : new Date(`${currentYear}-${currentMonth}-${currentDay}`);

                if (parseInt(currentMonth) > 5) {
                    currentYear += 1;
                }

                const departEndDate = dates?.depart?.end
                    ? new Date(dates.depart.end)
                    : new Date(`${currentYear}-${currentMonth}-${currentDay}`);


                departEndDate.setDate(departEndDate.getDate() - 1);

                if(!dates.creation) {
                    creationEndDate.setDate(creationEndDate.getDate() - 1);
                }

                const creationEnd = `${creationEndDate.getFullYear()}-${String(creationEndDate.getMonth() + 1).padStart(2, '0')}-${String(creationEndDate.getDate()).padStart(2, '0')}`;
                const departEnd = `${departEndDate.getFullYear()}-06-30`;
                if (parseInt(currentMonth) <= 12) {
                    currentYear -= 1;
                }
                const departStart = dates?.depart?.start || `${currentYear}-07-01`;

                const marge = isMargeRoute ? `&margin=NET` : '';
                const dateRef = isCARoute ? `&TypeView=depart` : '';
                const mobile = isMobile ? `&mobile=true` : '';

                const zoneGeoUser = localStorage.getItem('zone_geo_user');
                let zoneGeo = (zoneGeoUser !== 'undefined') ? `&Departement=${encodeURIComponent(zoneGeoUser)}` : '';

                if((localStorage.getItem('user_profile') == 'agent' || localStorage.getItem('user_profile') == 'commercial') && (zoneGeoUser === 'undefined' || zoneGeoUser.trim() === '')) {
                    zoneGeo = `&Departement=nok`
                }

                return `DepartStart=${departStart}&DepartEnd=${departEnd}&CreationStart=2021-01-01&CreationEnd=${creationEnd}${zoneGeo}${marge}${dateRef}${mobile}&isDefault=true`;
            }

        }

        try {
            if (logged) {
                showLoader()
                const kpiService = new KpiService();
                const storedDates = localStorage.getItem('dates');
                const dates = storedDates ? JSON.parse(storedDates) : {};
                const query = getFilterQuery(dates, isMargeRoute, isCARoute, isMobile);
                const kpi = await kpiService.getKPIReport(page, query);
                kpi.data.dateRef = "depart";
                this.handleKpiUpdate(kpi.data, setKpi);
                hideLoader()
            } else {
                navigate('/login')
            }

        } catch (err) {
            console.log(err.message);
        }
    }

    handleKpiUpdate(newsKpi, setKpi) {
        const page = this.getPage();
        const data = page.replace('/', '');
        const kpiData = newsKpi[data];

        const formatNumber = (num) => num?.toLocaleString('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });

        const formatKpiData = (kpiData, suffix = '') => ({
            [`currentWeekCA${suffix}`]: {
                [`title${suffix}`]: "CA de la semaine en cours",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentWeekCA)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.weekEvolution)} %`,
                [`content3${suffix}`]: "VS total semaine année précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearWeekCA)} €`
            },
            [`annualCA${suffix}`]: {
                [`title${suffix}`]: "CA annuel vs N-1 à la même date",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentCA)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolution)} %`,
                [`content3${suffix}`]: "/ période précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearCA)} €`
            },
            [`annualCADyn${suffix}`]: {
                [`title${suffix}`]: "CA recherche en cours",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentCADyn)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolutionDyn)} %`,
                [`content3${suffix}`]: "/ année précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearCADyn)} €`
            },
            [`objectiveCA${suffix}`]: {
                [`title${suffix}`]: "CA vs Objectif",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentCADepart)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.objEvolution)} %`,
                [`content3${suffix}`]: "/ objectif",
                [`content4${suffix}`]: `${formatNumber(kpiData?.currentObj)} €`
            },
            [`currentVsPreviousYearCA${suffix}`]: {
                [`title${suffix}`]: "CA en cours vs Total année précédente",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentCADepart)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearFullEvolution)} %`,
                [`content3${suffix}`]: "/ année précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousFullYearCA)} €`
            },
            [`currentMarge${suffix}`]: {
                [`title${suffix}`]: "Taux de marge vs N-1 à la même date",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentMarge)} %`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolution)} %`,
                [`content3${suffix}`]: "/ période précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearMarge)} %`
            },
            [`objectiveMarge${suffix}`]: {
                [`title${suffix}`]: "Taux de marge vs Objectif",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentMarge)} %`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.objPerc)} %`,
                [`content3${suffix}`]: "/ objectif",
                [`content4${suffix}`]: `${formatNumber(kpiData?.currentObj)} %`
            },
            [`currentVsPreviousYearMarge${suffix}`]: {
                [`title${suffix}`]: "Taux de marge en cours vs Total année précédente",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentMarge)} %`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearFullEvolution)} %`,
                [`content3${suffix}`]: "/ année précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousFullYearMarge)} %`
            },
            [`currentComm${suffix}`]: {
                [`title${suffix}`]: "Taux de commissions",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentComm)} %`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.evoComm)} %`,
                [`content3${suffix}`]: "/ année précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousComm)} %`
            },
            [`currentYearAchatReel${suffix}`]: {
                [`title${suffix}`]: "Achats réels moyens par nuit sur l'année VS année précédente",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentYearAchatReel)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolutionReel)} %`,
                [`content3${suffix}`]: "/ période précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearAchatReel)} €`
            },
            [`currentYearAchatPrev${suffix}`]: {
                [`title${suffix}`]: "Achats prévisionnels moyens par nuit sur l'année VS année précédente",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentYearAchatPrev)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolutionPrev)} %`,
                [`content3${suffix}`]: "/ période précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearAchatPrev)} €`
            },
            [`currentYearAchatPrev${suffix}`]: {
                [`title${suffix}`]: "Achats prévisionnels moyens par nuit sur l'année VS année précédente",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentYearAchatPrev)} €`,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolutionPrev)} %`,
                [`content3${suffix}`]: "/ période précédente",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousYearAchatPrev)} €`
            },
            [`currentPAX${suffix}`]: {
                [`title${suffix}`]: "Nombre de pax sur l'année VS année précédente",
                [`label${suffix}`]: `${kpiData?.label}`,
                [`content1${suffix}`]: `${formatNumber(kpiData?.currentPAX)} `,
                [`content2${suffix}`]: `${formatNumber(kpiData?.yearEvolution)} %`,
                [`content3${suffix}`]: "Vs N-1 SDLY",
                [`content4${suffix}`]: `${formatNumber(kpiData?.previousPAX)} `
            }
        });

        let newsKpiFormatted = {};
        if (Array.isArray(newsKpi)) {
            newsKpi.forEach((kpi, index) => {
                const suffix = index === 1 ? 'Second' : '';
                newsKpiFormatted = {
                        [`label${suffix}`]:kpi[data]?.label ,
                    // Ajout d'un suffixe aux clés de l'objet kpi pour les données secondaires
                    ...Object.fromEntries(
                        Object.entries(kpi).map(([key, value]) => [`${key}${suffix}`, value])
                    ),
                    ...newsKpiFormatted,
                    ...formatKpiData(kpi[data], suffix)
                };
            });
            newsKpiFormatted.dateRef = newsKpi.dateRef;
        } else {
            newsKpiFormatted = {
                ...newsKpi,
                ...formatKpiData(kpiData)
            };
        }
        setKpi(newsKpiFormatted);
    };

    async getKPIReport(page, query) {
        const result = await this.#api.getKPIReport(page, query);
        return result;
    }

    static checkHasValideDate(dates) {
        const newErrors = {};
        const oneYearInMs = 365 * 24 * 60 * 60 * 1000;
        let isAllValid = true;

        for (const [key, dateObj] of Object.entries(dates)) {
            if (dateObj.enabled) {
                if (dateObj.start && dateObj.end) {
                    const startDate = new Date(dateObj.start);
                    const endDate = new Date(dateObj.end);

                    if (startDate > endDate) {
                        newErrors[key] = "La date de début doit être antérieure à la date de fin.";
                        isAllValid = false;
                    }
                    // else if (endDate - startDate > oneYearInMs) {
                    //     newErrors[key] = "L'intervalle entre la date de début et la date de fin doit être d'un an maximum.";
                    //     isAllValid = false;
                    // }

                }
                // else {
                //     newErrors[key] = "Veuillez renseigner à la fois la date de début et la date de fin.";
                //     isAllValid = false;
                // }
            }
        }

        const hasAtLeastOneEnabledDate = Object.values(dates).some(dateObj => dateObj.enabled);
        const allEnabledDatesValid = Object.keys(newErrors).length === 0;

        if (!hasAtLeastOneEnabledDate) {
            newErrors.general = "Veuillez activer au moins un type de date.";
            isAllValid = false;
        } else if (!isAllValid && allEnabledDatesValid) {
            newErrors.general = "Veuillez corriger les erreurs dans les dates activées.";
            isAllValid = false;
        }

        return {isAllValid, newErrors};
    }

    static getDateQuery(dates, shouldCapitalize) {
        const queryParts = [];
        let start, end;

        for (const [key, dateObj] of Object.entries(dates)) {
            if (dateObj.enabled) {
                if(dateObj.start === '') {
                    start = '2021-01-01';
                } else {
                    start = dateObj.start
                }
                if(dateObj.end === '') {
                    end = '2100-01-01';
                } else {
                    end = dateObj.end
                }
                const processedKey = shouldCapitalize
                    ? key.charAt(0).toUpperCase() + key.slice(1)
                    : key;
                queryParts.push(`${processedKey}Start=${start}`);
                queryParts.push(`${processedKey}End=${end}`);
            }
        }

        return queryParts;
    }

    static getFilteredDataQuery(filteredData) {
        const queryParts = [];
        const zoneGeoUser = localStorage.getItem('zone_geo_user');

        console.log(localStorage.getItem('zone_geo_user'))
        for (const [dataKey, dataValues] of Object.entries(filteredData)) {
            for (let [categoriesKey, categories] of Object.entries(dataValues)) {
                if (Array.isArray(categories) && categories.length > 0) {
                    const values = categories.map(category => category.value);
                    // if (categoriesKey === 'Departement') {
                    //     if (zoneGeoUser !== 'undefined') {
                    //         values.push(...zoneGeoUser.split(','));
                    //     }
                    // }
                    if (categoriesKey === 'Sélection des champs') categoriesKey = 'FieldsToInclude';
                    queryParts.push(`${categoriesKey}=${encodeURIComponent(values.join(','))}`);
                }
            }

            if (dataKey === 'comparisonField') {
                const formattedDataValue = dataValues.charAt(0).toLowerCase() + dataValues.slice(1);
                queryParts.push(`ComparisonField=${formattedDataValue}`)
            }

            if (dataValues.margin) {
                queryParts.push(`margin=${dataValues.margin}`);
            }
            if (dataValues.dateRef) {
                queryParts.push(`ViewType=${dataValues.dateRef}`);
            }
            if (dataValues.mobile) {
                queryParts.push(`mobile=true`);
            }
        }

        const hasDepartement = queryParts.some(part => part.startsWith("Departement="));
        if (zoneGeoUser !== 'undefined' && !hasDepartement) {
            queryParts.push(`Departement=${encodeURIComponent(zoneGeoUser)}`);
        }

        if((localStorage.getItem('user_profile') == 'agent' || localStorage.getItem('user_profile') == 'commercial') && (zoneGeoUser === 'undefined' || zoneGeoUser.trim() === '')) {
            queryParts.push(`Departement=nok`);
        }

        return queryParts;
    }

    static getFilterQuery(queryParameters) {
        const {dates, filteredData, shouldCapitalize} = queryParameters;

        const dateQuery = this.getDateQuery(dates, shouldCapitalize);
        const filteredDataQuery = this.getFilteredDataQuery(filteredData);

        return [...dateQuery, ...filteredDataQuery].join('&');
    }

}
